<div class="relative px-12 pb-16">
  <!-- Main Content -->
  <div class="flex-1">
    @for (month of calendar; track $index) {
      <div class="w-full flex justify-between items-center px-10 py-4">
        <!-- Change buttons left -->
        <div
          class="rounded-full bg-primary-500 text-white flex items-center justify-center lg:h-8 lg:w-8 md:h-8 md:w-8 sm:h-6 sm:w-6 h-6 w-6 shadow-md cursor-pointer"
          (click)="slidePrev()"
        >
          <i
            class="pi pi-arrow-left lg:text-xl md:text-xl sm:text-xs text-xs"
          ></i>
        </div>

        <!-- Current month plus year -->
        <p
          class="text-center lg:text-xl md:text-xl sm:text-xs text-xs cursor-pointer"
          (click)="sidebarVisible = true"
        >
          {{ months[month.month].long }} / {{ month.year }}
        </p>

        <!-- Change buttons right -->
        <div
          class="rounded-full bg-primary-500 text-white flex items-center justify-center lg:h-8 lg:w-8 md:h-8 md:w-8 sm:h-6 sm:w-6 h-6 w-6 shadow-md cursor-pointer"
          (click)="slideNext()"
        >
          <i
            class="pi pi-arrow-right lg:text-xl md:text-xl sm:text-xs text-xs"
          ></i>
        </div>
      </div>
      <div class="grid grid-cols-7 gap-0 w-full">
        <!-- start days of the week -->
        <div class="col-span-1 py-2 pl-2 border-t border-gray-200">
          <p class="text-xs sm:text-xs lg:text-base md:text-base">Dom</p>
        </div>
        <div class="col-span-1 py-2 pl-2 border-t border-gray-200">
          <p class="text-xs sm:text-xs lg:text-base md:text-base">Lun</p>
        </div>
        <div class="col-span-1 py-2 pl-2 border-t border-gray-200">
          <p class="text-xs sm:text-xs lg:text-base md:text-base">Mar</p>
        </div>
        <div class="col-span-1 py-2 pl-2 border-t border-gray-200">
          <p class="text-xs sm:text-xs lg:text-base md:text-base">Mie</p>
        </div>
        <div class="col-span-1 py-2 pl-2 border-t border-gray-200">
          <p class="text-xs sm:text-xs lg:text-base md:text-base">Jue</p>
        </div>
        <div class="col-span-1 py-2 pl-2 border-t border-gray-200">
          <p class="text-xs sm:text-xs lg:text-base md:text-base">Vie</p>
        </div>
        <div class="col-span-1 py-2 pl-2 border-t border-gray-200">
          <p class="text-xs sm:text-xs lg:text-base md:text-base">Sab</p>
        </div>
        <!-- end days of the week -->
        @for (day of month.days; track $index) {
          <div
            #cell
            class="px-2 col-span-1 sm:h-20 lg:h-32 md:h-32 h-20 border-t border-gray-200 transition-all duration-200 no-select"
            [ngClass]="{
              'bg-gray-200 text-gray-400 cursor-not-allowed': day.disabled,
              'cursor-pointer': !day.disabled,
              'bg-primary-500/50': isToday(day.day, month.month, month.year),
            }"
            (dblclick)="
              !day.disabled
                ? onDoubleClick(day.day, month.month, month.year, cell)
                : ''
            "
            (click)="
              !day.disabled ? onClick(day.day, month.month, month.year) : ''
            "
          >
            @if (!isExpanded) {
              <p class="text-xs sm:text-xs lg:text-base md:text-base">
                {{ day.day }}
              </p>
            }
            @if (!day.disabled && !isExpanded) {
              <c-event-list
                [eventos]="getEvents(month.month, month.year, day.day)"
              />
            }
            <div class="hidden day-expanded-body">
              <div class="flex justify-center items-center">
                <p
                  class="text-center mr-4 lg:text-base md:text-base sm:text-xs text-xs"
                >
                  {{ expandedDate | date: "EEEE, d 'de' MMM 'del' y" }}
                </p>

                <button
                  class="border border-primary-500 text-primary-500 px-1 rounded-md shadow-md hover:bg-primary-500 hover:text-white transition-all duration-200 text-xs"
                  (click)="otherAction = true; collapse()"
                >
                  Volver
                </button>
              </div>
              @if (isExpanded) {
                <c-event-time-view
                  [date]="expandedDate"
                  [events]="getEvents(month.month, month.year, day.day)"
                />
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>

<p-dialog
  [(visible)]="visible"
  [draggable]="false"
  [modal]="true"
  appendTo="body"
  [closable]="true"
  styleClass="lg:w-[90vw] md:w-[90vw] sm:w-screen w-screen lg:h-auto md:h-auto sm:h-screen h-screen min-h-[85vh]"
  [closeOnEscape]="false"
  (onHide)="close()"
>
  <ng-template pTemplate="header">
    <div class="flex justify-start items-start flex-col">
      <h1 class="text-xl">
        <b>{{ date | date: "d 'de' MMMM 'del' y" }}</b>
      </h1>
      <small class="mb-4 italic opacity-80">
        <b>Aquí podrá ver sus eventos pendientes o crear nuevos.</b>
      </small>
    </div>
  </ng-template>

  <p-tabs value="0">
    <p-tablist>
      <p-tab value="0">Nuevo evento</p-tab>
      <p-tab value="1">Lista de eventos</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <div>
          <!-- start new events -->
          <hr />
          <br />
          <p>Nuevo evento:</p>

          <div class="pt-5">
            <!-- Event name -->
            <p-floatLabel>
              <input
                pInputText
                id="name"
                class="w-full p-2 outline-none border"
                [(ngModel)]="nombre"
              />
              <label for="name">Nombre del evento</label>
            </p-floatLabel>
            <div class="hide" [ngClass]="{ show: error }">
              <div>
                <p class="text-primary-500">Debe completar el nombre</p>
              </div>
            </div>
          </div>

          <div class="text-center pt-4">
            <!-- All the day -->
            <p-checkbox
              [binary]="true"
              inputId="binary"
              label="Todo el día"
              [(ngModel)]="todoElDia"
            />
          </div>
          <div class="hide" [ngClass]="{ show: !todoElDia }">
            <div>
              <div class="grid grid-cols-12 gap-4 w-full pt-6">
                <div class="col-span-6">
                  <!-- Init time -->
                  <p-floatLabel>
                    <p-datepicker
                      inputId="calendar-init"
                      [timeOnly]="true"
                      styleClass="w-full"
                      inputStyleClass="w-full p-2 border"
                      appendTo="body"
                      hourFormat="24"
                      [(ngModel)]="inicio"
                      (ngModelChange)="fin = inicio"
                    />
                    <label for="calendar-init">Hora inicio</label>
                  </p-floatLabel>
                </div>
                <div class="col-span-6">
                  <!-- End time -->
                  <p-floatLabel>
                    <p-datepicker
                      inputId="calendar-end"
                      [timeOnly]="true"
                      styleClass="w-full"
                      inputStyleClass="w-full p-2 border"
                      appendTo="body"
                      hourFormat="24"
                      [(ngModel)]="fin"
                      [minDate]="inicio"
                    />
                    <label for="calendar-end">Hora fin</label>
                  </p-floatLabel>
                  <div class="hide" [ngClass]="{ show: error }">
                    <div>
                      <p class="text-primary-500">
                        El final del evento no puede ser anterior al inicio
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Color picker -->
          <div class="text-center pt-4">
            <p>Seleccione un color</p>
            <p-colorPicker
              [(ngModel)]="color"
              styleClass="border rounded-md"
              appendTo="body"
            />
          </div>

          <!-- Repeat options -->
          <div class="pt-4">
            <p-floatLabel>
              <p-select
                optionLabel="name"
                inputId="repeat"
                [options]="repeatOptions"
                [(ngModel)]="repeat"
                styleClass="w-full outline-none border"
                appendTo="body"
              />
              <label for="repeat">Repetir</label>
            </p-floatLabel>
          </div>

          <br />

          <!-- Alert options -->
          <div class="pt-4">
            <p-floatLabel>
              <p-select
                optionLabel="name"
                inputId="alert"
                [options]="alertOptions"
                [(ngModel)]="alert"
                styleClass="w-full outline-none border"
                appendTo="body"
              />
              <label for="alert">Alerta</label>
            </p-floatLabel>
          </div>
        </div>
        <!-- end new events -->

        <br />
        <hr />
        <br />

        <div class="pt-4 flex justify-end items-center gap-4">
          <button
            class="border border-tertiary-500 text-tertiary-500 p-2 rounded-md shadow-md hover:bg-tertiary-500 hover:text-white transition-all duration-200"
            (click)="submit()"
          >
            Aceptar
          </button>
          <button
            class="border border-primary-500 text-primary-500 p-2 rounded-md shadow-md hover:bg-primary-500 hover:text-white transition-all duration-200"
            (click)="close()"
          >
            Cancelar
          </button>
        </div>
      </p-tabpanel>
      <p-tabpanel value="1">
        @if (visible) {
          @for (event of events; track $index) {
            <c-event-view
              [event]="event"
              [date]="date"
              (removeItem)="removeItem($event)"
            />
          }
        }
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</p-dialog>

<c-dialog #dialog />


<p-drawer
  [(visible)]="sidebarVisible"
  position="top"
  [styleClass]="'h-[180px]'"
>
  <h3 class="text-center mb-2">
    <b>
      Seleccione una fecha ó
      <button
        (click)="goToday()"
        class="rounded-md bg-secondary-400 text-white shadow-md px-2"
      >
        Ir a HOY
      </button>
    </b>
  </h3>
  <p-datepicker
    view="month"
    dateFormat="mm/yy"
    [readonlyInput]="true"
    styleClass="w-full"
    inputStyleClass="w-full p-2 border"
    appendTo="body"
    [(ngModel)]="monthPicker"
    (ngModelChange)="changeMonthPicker()"
  />
</p-drawer>
